import {
    setAmcApplicationApiStatus,
    setVehicleMakeReferenceData,
    setVehicleModelReferenceData,
    AMC_VEHICLE_MAKE_REFERENCE_DATA_GET_VALUE,
    AMC_VEHICLE_MODEL_REFERENCE_DATA_GET_VALUE,
} from '../../../actions/allSureMotorClaim/referenceData';
import axios from 'axios';
import { API_CALL_STATUS } from '../../../reducers/status';

export const referenceDataService = (store, next, action) => {
    const result = next(action);
    if (action.type === AMC_VEHICLE_MAKE_REFERENCE_DATA_GET_VALUE) {
        (async () => {
            const vehicleMakeReferenceData = await fetchVehicleMakeReferenceData();
            if (vehicleMakeReferenceData) {
                store.dispatch(setVehicleMakeReferenceData(vehicleMakeReferenceData.data));
            } else {
                store.dispatch(setAmcApplicationApiStatus(API_CALL_STATUS.FAILURE));
            }
        })();
    }
    if (action.type === AMC_VEHICLE_MODEL_REFERENCE_DATA_GET_VALUE) {
        (async () => {
            const vehicleModelReferenceData = await fetchVehicleModelReferenceData(action.value);
            if (vehicleModelReferenceData) {
                store.dispatch(setVehicleModelReferenceData(vehicleModelReferenceData.data));
                store.dispatch(setAmcApplicationApiStatus(API_CALL_STATUS.SUCCESS));
            } else {
                store.dispatch(setAmcApplicationApiStatus(API_CALL_STATUS.FAILURE));
            }
        })();
    }

    return result;
};

export const fetchVehicleMakeReferenceData = async () => {
    try {
        const response = await axios({
            url: '/om-api/allsure-insurance/reference-data/vehicle-makes',
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Access-Control-Allow-Origin': 'null',
            },
        });
        return response;
    } catch (error) {
        return null;
    }
};
export const fetchVehicleModelReferenceData = async (vehicleMakeCode) => {
    try {
        const response = await axios({
            url: `/om-api/allsure-insurance/reference-data/vehicle-models?vehicleMake=${vehicleMakeCode}`,
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Access-Control-Allow-Origin': 'null',
            },
        });
        return response;
    } catch (error) {
        return null;
    }
};
